// extracted by mini-css-extract-plugin
export default {"fieldDesc":"fieldDesc__Nv2uP"};